import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { FormGroup, FormControl, Validators } from '@angular/forms';

// Models
import { AreaData, ReasonData } from 'src/app/modules/procedures/models/procedures';

// Service
import { UiService } from 'src/app/platform/services/ui.service';
import { PlatformService } from 'src/app/platform/services/platform.service';
import { ProceduresService } from 'src/app/modules/procedures/procedures.service';

@Component({
  selector: 'app-procedures-new',
  templateUrl: './procedures-new.component.html',
  styleUrls: ['./procedures-new.component.scss']
})
export class ProceduresNewComponent implements OnInit {
  public formData: FormGroup = new FormGroup({
    area: new FormControl('', [Validators.required]),
    reason: new FormControl('', [Validators.required]),
    message: new FormControl('', [Validators.required]),
  });
  public areasData: Array<AreaData>;
  public reasonsData: Array<ReasonData>;

  constructor(
    private dialog: MatDialogRef<ProceduresNewComponent>,
    private uiService: UiService,
    private platformService: PlatformService,
    private proceduresService: ProceduresService,
  ) { }

  ngOnInit(): void {
    this.uiService.showSpinner(true);

    this.proceduresService.areasGet().then((success) => {
      this.uiService.showSpinner(false);
      this.areasData = success.result;
    }).catch((error) => {
      this.uiService.showSpinner(false);
      this.dialog.close();
      this.uiService.dialogShow('Ups!', 'No es realizar una nueva gestión en este momento. Estamos trabajando para solucionar el inconveniente.', 'alert');
    });
  }

  onCancel(): void {
    this.dialog.close();
  }

  onAreaChange(reason: number): void {
    if (reason >= 1) {
      this.uiService.showSpinner(true);

      this.proceduresService.reasonsGet(reason).then((success) => {
        this.uiService.showSpinner(false);
        this.reasonsData = success.result;
      }).catch((error) => {
        this.uiService.showSpinner(false);
        this.dialog.close();
        this.uiService.dialogShow('Ups!', 'No es realizar una nueva gestión en este momento. Estamos trabajando para solucionar el inconveniente.');
      });
    } else {
      this.reasonsData = [];
    }
  }

  onSubmit(): void {
    if (this.formData.valid) {
      this.uiService.showSpinner(true);

      this.proceduresService.proceduresNew(
        this.formData.get('area')?.value,
        this.formData.get('reason')?.value,
        this.formData.get('message')?.value
      ).then((result) => {
        if (result.status) {
          this.dialog.close();
          this.proceduresService.proceduresUpdate(true);

          this.uiService.showSpinner(false);
          this.uiService.dialogShow('Gestión inciada', 'Iniciamos tu gestión, a la brevedad la revisaremos para dar una respuesta a tu solicitud. Tu número de gestión es: <p><h1>' + result.result.id + '</h1></p>', 'success');
        }
        else {
          this.uiService.showSpinner(false);
          this.uiService.dialogShow('Ups!', 'Hubo un inconveniente al intentar generar la gestión. Por favor intenta nuevamente.', 'error');
        }
      }, (error) => {
        this.uiService.showSpinner(false);
        this.uiService.dialogShow('Ups!', 'No es posible generar la gestión en este momento. Estamos trabajando para solucionar el inconveniente.', 'alert');
      });
    } else {
      this.formData.markAllAsTouched();
      this.uiService.showSnackBar('Algunos datos no están completos');
    }
  }

  formHasError(formcontrol: string, data: string): any {
    const fields: any = {
      area: {
        required:  'Seleccione un área'
      },
      reason: {
        required:  'Seleccione un  motivo',
      },
      message: {
        required:  'Ingrese una descripción para su consulta',
      }
    };

    return this.platformService.formHasError(this.formData, fields, formcontrol, data);
  }
}
